import { render, staticRenderFns } from "./AdminAttendanceStudent.vue?vue&type=template&id=19bd5c36"
import script from "./AdminAttendanceStudent.vue?vue&type=script&lang=js"
export * from "./AdminAttendanceStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports